import { Component } from '@angular/core';
import {RouterLink, RouterLinkActive} from "@angular/router";

@Component({
  selector: 'app-team-home',
  standalone: true,
  imports: [
    RouterLink,
    RouterLinkActive,],
  templateUrl: './team-home.component.html',
  styleUrl: './team-home.component.css'
})
export class TeamHomeComponent {

}
